/* eslint-disable max-len */
/** @jsx jsx */

import React, { useState } from 'react';
// import Appbar from 'components/organismos/Appbar';
// import useLoginUser from 'hooks/useLoginUser';
import { Container } from 'react-grid-system';
// import TopBar from 'components/atoms/TopBar';
import { useHistory, useLocation } from 'react-router-dom';
// import TabBar, { TablItem } from 'components/atoms/TabBar';
// import Icon, {IconType} from 'components/atoms/Icon';
import { css, jsx } from '@emotion/core';
// import { toast } from 'react-toastify';
// import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
// import BodyText from "components/atoms/BodyText";
// import BoxGroupMenu from "components/molecules/Menu/BoxGroupMenu";
// import BreadCrumb from "components/atoms/BreadCrumb";
// import { productColor } from 'components/styles';
// import { menuListHQ } from './menuData'
// import { getMenuListByRole } from './menuData'
// import TabMenuBar from './TabMenuBar'
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';

import { toast } from 'react-toastify';
import { hokuyoCompanyCode } from 'const';
const style = {
  container: css({
    width: '100%', 
    maxWidth: '1750px', 
    margin: 'auto', 
    justifyContent: 'space-between', 
    marginTop: '35px',
  }),
  backHistory: css({
    position: 'absolute',
    top: '8px',
    left: '-65px'
  },
    css`&:hover svg{
    opacity:0.7
  }`,
  ),
  boxItem: css({
    padding: "8px 26px", 
    color: "#999999", 
    fontSize: "12px"
  }),
  boxSubItem: css({
    padding: "7px", 
  }),
  logo: css({
    color: "#363D3D",
    fontWeight: "bold",
    fontSize: "18px",
    marginLeft: "7px",
  }),
  logoContainer: css({
    borderBottom: "1px solid #e6e6e6",
    paddingBottom: '20px',
  }),
}

const SidebarTemplate: React.FC<{
  pageTitle?: string;
}> = ({ children, pageTitle }) => {

  const location = useLocation();
  const history = useHistory();
  let group = location.pathname.split('/')[1];
  const [indexOpen, setIndexOpen] = useState<number|null>()
  const collapsedSidebar = useSelector((state:Store) => state.ui.appBar.collapsedSidebar);
  const isPhone = window.matchMedia("(max-width: 480px)").matches;
  
  return (
    <React.Fragment>
      <div css={css({
        paddingLeft: isPhone? 0: '15px',
        maxWidth: collapsedSidebar ? (isPhone? '100%': 'calc(100% - 60px)') : 'calc(100% - 245px)',
        width: collapsedSidebar ? (isPhone? '100%': 'calc(100% - 60px)') : 'calc(100% - 245px)',
        // transition: 'max-width 0.5s',
        position: 'relative'
      })}>
        <div> 
          <Container fluid>
            {/* {
              (group !== 'agreement36') &&
                sessionStorage.getItem("isGoBack") === String(1)
                ? <div css={style.backHistory} onClick={() => history.goBack()} > <Icon type="back" color="#666" /> </div>
                : null
            } */}
            {children}
          </Container>
        </div>
        {/* <BreadCrumb
          menu={getMenuListByRole()}
        /> */}
      </div>
    </React.Fragment>
  );
};

export default SidebarTemplate;
